/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import TextField from 'shared/components/text-field/TextField';
import Button from 'shared/components/button/Button';
import CheckBox from 'shared/components/check-box/CheckBox';
import RadioButton from 'shared/components/radio-button/RadioButton';
import { Formik, Form, useField } from 'formik';
import { addClientSchema } from 'utils/validators/addClient';
import PhoneInput from 'react-phone-number-input';

class ClientAdd extends React.Component {
  render() {
    const { toggle, openModal, error } = this.props;

    return (
      <div>
        <Modal isOpen={openModal} className="add-client-modal">
          <ModalHeader>
            <span>Add New Client</span>
            <a className="modal-close" onClick={toggle}>
              Close
            </a>
          </ModalHeader>
          <ModalBody>
            <Formik
              initialValues={{
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                inviteByEmail: ['inviteByEmail'],
                inviteBySMS: '',
                measurementUnit: 'lbs'
              }}
              validationSchema={addClientSchema}
              onSubmit={async values => {
                return this.props.addClient(values);
              }}
              initialErrors={'email'}
            >
              {({ isSubmitting, isValid, values, errors }) => (
                <Form>
                  <div className="form-row">
                    <div className="col">
                      <TextField
                        type="text"
                        name="firstName"
                        label="First Name"
                        placeholder="First Name"
                      />
                    </div>
                    <div className="col">
                      <TextField
                        type="text"
                        name="lastName"
                        label="Last Name"
                        placeholder="Last Name"
                      />
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="col">
                      <TextField
                        type="text"
                        name="email"
                        label="Email"
                        error={error && error.code ? error.message : false}
                        placeholder="client@email.com"
                      />
                    </div>
                    <div className="col">
                      <PhoneNumber
                        fieldName="phoneNumber"
                        label="Phone Number"
                        placeholder="Phone Number"
                        inviteBySMS={values.inviteBySMS.length}
                      />
                    </div>
                  </div>

                  <div className="form-row form-check-row">
                    <div className="col">
                      <label className="form-label">
                        Invite them to Hybrid via:
                      </label>
                      <div className="form-check-inline">
                        <CheckBox
                          id=""
                          text="Email"
                          name="inviteByEmail"
                          value="inviteByEmail"
                        />
                        <CheckBox
                          text="SMS"
                          name="inviteBySMS"
                          value="inviteBySMS"
                        />
                      </div>
                      {errors.addClientCheckboxes && (
                        <div className="input-feedback">
                          {errors.addClientCheckboxes}
                        </div>
                      )}
                    </div>
                    <div className="col">
                      <label className="form-label">
                        UNITS OF MEASUREMENT:
                      </label>
                      <div className="form-check-inline">
                        <RadioButton
                          text="Pounds"
                          name="measurementUnit"
                          value="lbs"
                          checked={values.measurementUnit === 'lbs'}
                        />
                        <RadioButton
                          text="Kilograms"
                          name="measurementUnit"
                          value="kgs"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-action">
                    <Button
                      disabled={isSubmitting}
                      id=""
                      type="submit"
                      btnBlock=""
                      btnSize=""
                      color="primary"
                      label="Save and Invite"
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function PhoneNumber({ fieldName, label, placeholder, inviteBySMS }) {
  const [field, meta, helpers] = useField(fieldName);
  return (
    <div className="form-group">
      <label className="form-label">{label}</label>
      <PhoneInput
        className="phone-form-group"
        placeholder={placeholder}
        name={field.name}
        value={field.value}
        onChange={helpers.setValue}
        limitMaxLength={true}
        defaultCountry="HK"
        international
        numberInputProps={{ className: 'form-control' }}
        disabled={!inviteBySMS}
      />
      {meta.touched && meta.error && (
        <div className="input-feedback">{meta.error}</div>
      )}
    </div>
  );
}

export default ClientAdd;
